<template lang="html">
  <article class="form" @click="slideUpList">
    <p class="industry">
      <label>选择你想要推广的行业：</label>
      <span class="select" :class="{ 'text-prompt': unseleced }" @click.stop.prevent="dropMenu = !dropMenu">{{ selectedIndustry }}</span>
      <img src="/static/launchPreview/arrow-down.png" alt="下拉按钮">
      <ul v-show="dropMenu" class="industry-list">
        <li v-for="item in industryList" @click="selectIndustry(item.id, item.name)">{{ item.name }}</li>
      </ul>
      <div class="text-gray pull-left">* 系统将根据行业适配广告创意模板</div>
    </p>
    <p>
      <label>请输入推广的文字描述：</label>
      <input type="text" placeholder="可输入4-15个文字" v-model="title">
      <div class="text-gray pull-left">* 请输入所要推广的企业/产品信息</div>
    </p>
    <p>
      <label>请输入来电咨询的方式：</label>
      <input type="text" placeholder="可输入8-13个数字" v-model="contact">
      <div class="text-gray pull-left">
        * 请输入客服电话/联系人手机号码
      </div>
    </p>
    <p>
      <label>请输入您想推广的网址：</label>
      <input type="text" placeholder="www.adyun.com" v-model="link">
      <div class="text-gray pull-left">
        如果暂无可以不填写
      </div>
    </p>
  </article>
</template>

<script>
export default {
  props: ['industryList'],
  data () {
    return {
      industryname: '',
      dropMenu: false,
      selectedId: undefined,
      selectedIndustry: '请选择你想推广的行业',
      unseleced: true,
      title: undefined,
      contact: undefined,
      link: ''
    }
  },
  methods: {
    selectIndustry (id, industry) {
      if (this.unseleced) { this.unseleced = false }
      this.$set(this, 'selectedId', id)
      this.$set(this, 'selectedIndustry', industry)
      this.dropMenu = false
    },
    slideUpList () {
      if (this.dropMenu) { this.dropMenu = false }
    }
  }
}
</script>

<style lang="less" scoped>
.industry {
  position: relative;
  img {
    position: absolute;
    width: 12px;
    right: 12px;
    top: 20px;
  }
  .industry-list {
    position: absolute;
    list-style: none;
    width: 223px;
    height: 225px;
    overflow-y: auto;
    background-color: #fff;
    box-shadow: 0px 10px 15px 2px #888;
    top: 25px;
    left: 164px;
    padding: 0;
    li {
      height: 25px;
      cursor: pointer;
      padding: 5px 10px;
      &:hover {
        background-color: #4285f4;
        color: #fff;
      }
    }
  }
}
.text-gray {
  color: #dc2121;
  font-size: 12px;
  margin-left: 163px;
}
p {
  padding: 5px 0;
  text-align: left;
  margin-bottom: 10px;
  margin-top: 10px;
  label {
    margin-right: 5px;
  }
  input, .select {
    width: 225px;
    height: 34px;
    padding: 0 8px;
    border: 1px solid #ccc;
    border-radius: 2px;
    outline: none;
    box-sizing: border-box;  
  }
  .select {
    display: inline-block;
    padding-top: 8px;
    cursor: pointer;
  }
  .text-prompt {
    color: #a5a5a5;
  }
}
</style>



// WEBPACK FOOTER //
// launchModal.vue?28e8325a